// removed by extract-text-webpack-plugin
module.exports = {"block":"AppInstalls__block-1msuM","icon":"AppInstalls__icon-2fyGj"};